import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mca } from '@mycoverai/mca-react-sdk'
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import ShieldIcon from '@mui/icons-material/Security'; // Import shield icon
import {
  AppBar,
  TextField,
  Card,
  Chip,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
  Typography,
  Box,
  Container,
  Grid,
  Paper,
  Avatar,
  Snackbar,
  Alert
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import AuthenticateService from './AuthenticateService';

const AppUrl = {otherMyCoverInsurancePay:"users/other-bills/insurance/cover-product",
                otherMyCoverInsuranceWalletreference:"users/other-bills/insurance/cover-wallet-reference"
                }

const ProductSelectionScreen = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [userData, setUserData] = useState(null);
  const [walletReference, setWalletReference] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
   const [openMcaModal, setOpenMcaModal] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    walletReference: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });
const { http, user } = AuthenticateService();

  useEffect(() => {
    fetchProducts();
    getUserData();
  }, []);

  useEffect(() => {
    filterProducts();
  }, [searchTerm, products]);

  const getUserData = async () => {
    try {
      if (user) {
        setUserData(user);
        setCustomerInfo(prev => ({
          ...prev,
          email: user.email || '',
          firstName: user.first_name || '',
          lastName: user.last_name || '',
          phone: user.phone || ''
        }));
      }
    } catch (error) {
      showSnackbar('Error loading user data', 'error');
    }
  };

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      await productReference();

      // Simulate API call - replace with actual API call
      const response = await http.get(`${AppUrl.otherMyCoverInsurancePay}`);
      if (response.data.status === true) {
        setProducts(response.data.data?.products || []);
      } else {
        showSnackbar('Failed to load products', 'error');
      }
    } catch (error) {
      showSnackbar(`Error: ${error.message}`, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const productReference = async () => {
    try {
        console.log('---------reference----------')

      // Simulate API call - replace with actual API call
      const response = await http.get(`${AppUrl.otherMyCoverInsuranceWalletreference}`);

      if (response.data.status === true ) {

        setWalletReference(response.data?.data?.data || '');
        setCustomerInfo(prev => ({
          ...prev,
          walletReference:response.data?.data?.data|| ''
        }));
      } else {
        showSnackbar('Failed to load wallet reference', 'error');
      }
    } catch (error) {
      showSnackbar(`Error: ${error.message}`, 'error');
    }
  };

  const filterProducts = () => {
    if (!searchTerm) {
      setFilteredProducts([...products]);
      return;
    }

    const filtered = products.filter(product => {
      return (
        (product.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.provider.company_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.productCategory?.name.toLowerCase().includes(searchTerm.toLowerCase())) || false
      );
    });

    setFilteredProducts(filtered);
  };

  const toggleProductSelection = (productId) => {
    setSelectedProductIds(prev =>
      prev.includes(productId)
        ? prev.filter(id => id !== productId)
        : [...prev, productId]
    );
  };

  const handleProceed = () => {
    if (selectedProductIds.length === 0) {
      showSnackbar('Please select at least one product', 'warning');
      return;
    }
    setOpenDialog(true);
  };

  const handlePurchase = () => {
    setIsSubmitting(true);
    setOpenDialog(false);
    setOpenMcaModal(true);
    // Navigate to purchase screen or show MyCoverAI component
  };

  const parseHtmlString = (htmlString) => {
    if (!htmlString) return '';
    return htmlString
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim();
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };
 const McaPaymentModal = ({ open, onClose }) => {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Complete Your Purchase</DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <Mca publicKey="MCAPUBK_TEST|a06086e6-54be-4ff1-9692-a35db3d0e26b"
            email={customerInfo.email}
          form={{
            email: customerInfo.email,
            first_name: customerInfo.firstName,
            last_name: customerInfo.lastName,
            phone: customerInfo.phone
          }}
            onComplete={(response) => {
            const policy = response.policyModel;
            showSnackbar(`Purchase successful! Policy ID: ${policy.id}`, 'success');
            setIsSubmitting(false);
          }}
          onClose={(result) => {
            setIsSubmitting(false);
          }}
          transactionType="purchase"
          isContactFieldsEditable={false}
          paymentOption="wallet"
          productId={selectedProductIds}
          debitWalletReference={customerInfo.walletReference}
           >


  <Button
    variant="contained"
    color="success"
    size="large"
    fullWidth
    sx={{
      height: 56,
      borderRadius: 1,
      fontWeight: 'medium',
      fontSize: '1rem',
      textTransform: 'none',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: 'success.dark'
      }
    }}
    startIcon={<ShieldIcon />}
  >
    Proceed Insurance
  </Button>

          </Mca>

            {/* <Mca
              publicKey="MCAPUBK_TEST|a06086e6-54be-4ff1-9692-a35db3d0e26b"
              email={customerInfo.email}
              form={{
                email: customerInfo.email,
                first_name: customerInfo.firstName,
                last_name: customerInfo.lastName,
                phone: customerInfo.phone
              }}
              onComplete={(response) => {
                const policy = response.policyModel;
                showSnackbar(`Purchase successful! Policy ID: ${policy.id}`, 'success');
                onClose();
              }}
              onClose={(result) => {
                onClose();
              }}
              transactionType="purchase"
              isContactFieldsEditable={false}
              paymentOption="wallet"
              productId={selectedProductIds}
              debitWalletReference={customerInfo.walletReference}
            /> */}
          </Box>
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <>
      <Sidebar />
      <Header user={user} />
      <div className="content bg-light" >
      <AppBar position="static">
        <Container>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Select Insurance Products</Typography>
            {selectedProductIds.length > 0 && (
              <Chip label={selectedProductIds.length} color="primary" />
            )}
          </Box>
        </Container>
      </AppBar>

      <Container maxWidth="md" sx={{ mt: 3 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />
          }}
          sx={{ mb: 3 }}
        />

        {isLoading ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
          </Box>
        ) : filteredProducts.length === 0 ? (
          <Typography variant="body1" textAlign="center" my={4}>
            No products found
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {filteredProducts.map((product,index) => (
              <Grid item xs={12} key={product.id+index}>
                <ProductCard
                  product={product}
                  isSelected={selectedProductIds.includes(product.id)}
                  onSelect={() => toggleProductSelection(product.id)}
                  parseHtmlString={parseHtmlString}
                />
              </Grid>
            ))}
          </Grid>
        )}

        {selectedProductIds.length > 0 && (
          <Box display="flex" justifyContent="flex-end" mt={3} mb={6}>
            <Button
              variant="contained"
              color="primary"
              endIcon={isSubmitting ? <CircularProgress size={24} color="inherit" /> : <ArrowForwardIcon />}
              onClick={handleProceed}
              disabled={isSubmitting}
            >
              Proceed ({selectedProductIds.length})
            </Button>
          </Box>
        )}
      </Container>

      <CustomerInfoDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmit={handlePurchase}
        customerInfo={customerInfo}
        setCustomerInfo={setCustomerInfo}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSubmitting && (
                <>
                 <McaPaymentModal
        open={openMcaModal}
        onClose={() => setOpenMcaModal(false)}
      />
        {/* <Mca publicKey="MCAPUBK_TEST|a06086e6-54be-4ff1-9692-a35db3d0e26b"
            email={customerInfo.email}
          form={{
            email: customerInfo.email,
            first_name: customerInfo.firstName,
            last_name: customerInfo.lastName,
            phone: customerInfo.phone
          }}
            onComplete={(response) => {
            const policy = response.policyModel;
            showSnackbar(`Purchase successful! Policy ID: ${policy.id}`, 'success');
            setIsSubmitting(false);
          }}
          onClose={(result) => {
            setIsSubmitting(false);
          }}
          transactionType="purchase"
          isContactFieldsEditable={false}
          paymentOption="wallet"
          productId={selectedProductIds}
          debitWalletReference={customerInfo.walletReference} >
           <button className="w-[300px] h-[56px] bg-green-700 text-white font-medium rounded-md">
       Buy Insurance
    </button>
          </Mca> */}
          </>
      )}
    </div>
    <Footer/>
    </>

  );
};

const ProductCard = ({ product, isSelected, onSelect, parseHtmlString }) => {
  return (
    <Card
      sx={{
        border: `1px solid ${isSelected ? '#1976d2' : '#e0e0e0'}`,
        borderRadius: 2,
        overflow: 'hidden'
      }}
    >
      <Box display="flex">
        {/* Logo Section */}


        {/* Content Section */}
        <Box flexGrow={1} p={2}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Typography variant="subtitle1" fontWeight="medium">

        <span style={{marginRight:5}}>
        {product.provider?.settings?.logo ? (
            <img src={product.provider.settings.logo} width='100' />
          ) : (
            <BusinessIcon sx={{ fontSize: 36, color: 'grey.500' }} />
          )}</span>{product.name} By {product.provider.company_name}
            </Typography>
            <Checkbox
              checked={isSelected}
              onChange={onSelect}
              color="primary"
            />
          </Box>

          <Box mt={1}>
            <Paper
              variant="outlined"
              sx={{
                display: 'inline-block',
                px: 1,
                py: 0.5,
                bgcolor: 'success.light',
                borderColor: 'success.light'
              }}
            >
              <Typography variant="body2" color="success.dark" fontWeight="medium">
                ₦{parseFloat(product.price).toFixed(2)}
              </Typography>
            </Paper>
          </Box>

          <Typography variant="body2" color="text.secondary" mt={2} sx={{ minHeight: 40 }}>
            {parseHtmlString(product.key_benefits)}
          </Typography>

          {product.productCategory && (
            <Box display="flex" alignItems="center" mt={2}>
              <CategoryIcon sx={{ fontSize: 16, color: 'grey.500', mr: 0.5 }} />
              <Typography variant="caption" color="text.secondary">
                {product.productCategory.name}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  );
};

const CustomerInfoDialog = ({ open, onClose, onSubmit, customerInfo, setCustomerInfo }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    // Basic validation
    if (!customerInfo.email || !customerInfo.firstName || !customerInfo.lastName || !customerInfo.phone) {
      return;
    }
    onSubmit();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Your Information</DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            fullWidth
            label="Email"
            name="email"
            value={customerInfo.email}
            onChange={handleChange}
            disabled
            required
          />
          <TextField
            margin="normal"
            fullWidth
            label="First Name"
            name="firstName"
            value={customerInfo.firstName}
            onChange={handleChange}
            required
          />
          <TextField
            margin="normal"
            fullWidth
            label="Last Name"
            name="lastName"
            value={customerInfo.lastName}
            onChange={handleChange}
            required
          />
          <TextField
            margin="normal"
            fullWidth
            label="Phone Number"
            name="phone"
            value={customerInfo.phone}
            onChange={handleChange}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductSelectionScreen;